import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import { SectionsStatusKey } from './SectionStatusSchema';

/**
 * Espone le funzionalità per modificare lo stato delle sezioni.
 * `setTouched` non è esposto in quanto può essere impostato solo
 * automaticamente dal motore, dopo il "Salva e Procedi"
 */
export function useRuntimeSectionStatusHandler() {
  const methods = useFormContext();

  const setOpened = useCallback(
    (sectionId: string) => {
      methods.setValue(`${SectionsStatusKey}.${sectionId}.opened`, true);
    },
    [methods],
  );

  return { setOpened };
}
